import React, { useState } from "react";
import "../../index.css";

function FloatingLabelInput({ label, id, name, type = "text", value, inputMode, check_type, error, required = false, onChange, disabled = false, autoFocus = false, textAlign = "auto", addon = null, onKeyDown, fontSize = "16px" }) {
	const [isFocused, setIsFocused] = useState(false);
	const hasText = value && value.length > 0;

	let validationError = "";
	if (check_type === "email" && value) {
		if (!/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
			validationError = "Az email cím legyen érvényes (pl: info@elitcipo.hu)!";
		}
	}
	if (check_type === "phone" && value) {
		if (!/^[0-9+\-\s()]{6,}$/.test(value)) {
			validationError = "Érvényes telefonszámot adj meg!";
		}
	}
	if (check_type === "name" && value) {
		if (!/^[a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ .-/!/+]{2,}$/.test(value)) {
			validationError = "Kérjük, adjon meg egy nevet!";
		}
	}
	if (type === "date" && value) {
		if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || isNaN(new Date(value).getTime())) {
			validationError = "Kérjük, érvényes dátumot adjon meg (éééé-hh-nn)!";
		}
	}

	const isInvalid = !!(error || validationError);

	const isNumberInput = type === "number" || type === "tel";
	const finalTextAlign = textAlign === "auto" 
	? (isNumberInput ? "right" : "left") 
		: textAlign;
	
	const inputStyle = {
		textAlign: finalTextAlign,
		fontSize,
		...(isNumberInput && {
			paddingRight: addon ? '1rem' : '1rem',
			MozAppearance: 'textfield',
			WebkitAppearance: 'none',
			'&::-webkit-outer-spin-button': {
				WebkitAppearance: 'none',
				margin: 0
			},
			'&::-webkit-inner-spin-button': {
				WebkitAppearance: 'none',
				margin: 0
			}
		})
	};

	const inputClassName = `form-control ${isInvalid ? "is-invalid" : ""} ${isNumberInput ? "no-spinners" : ""}`;

	if (addon) {
        return (
            <div className={`custom-floating-input input-group-wrapper ${isFocused || hasText ? "active" : ""}`}>
                <div className="input-group">
                    <input
                        type={type}
                        id={id}
                        name={name}
                        className={inputClassName}
                        style={inputStyle}
                        value={value}
                        onChange={onChange}
                        required={required}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        autoComplete="off"
                        readOnly={disabled}
                        disabled={disabled}
                        autoFocus={autoFocus}
						placeholder=" "
                        onKeyDown={onKeyDown}
                    />
                    <span className="input-group-text">{addon}</span>
					<label htmlFor={id} className="floating-label">{label}</label>
                </div>
                {isInvalid && <div className="invalid-feedback">{error || validationError}</div>}
            </div>
        );
    }

	return (
		<div className={`custom-floating-input ${isFocused || hasText ? "active" : ""}`}>
			<input
				type={type}
				id={id}
				name={name}
				className={inputClassName}
				style={inputStyle}
				value={value}
				onChange={onChange}
				required={required}
				onFocus={() => setIsFocused(true)}
				onBlur={() => setIsFocused(false)}
				autoComplete="off"
				readOnly={disabled}
				disabled={disabled}
				autoFocus={autoFocus}
				onKeyDown={onKeyDown}
				inputMode={inputMode}
			 />
			<label htmlFor={id}>{label}</label>
			{isInvalid && <div className="invalid-feedback">{error || validationError}</div>}
		</div>
	);
}

export default FloatingLabelInput;
